import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'index',
    pathMatch: 'full'
  },
  {
    path: 'index',
    loadChildren: () => import('./pages/landing/landing.module').then( m => m.LandingPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'seat-booking/show/:show_id/date/:date',
    loadChildren: () => import('./pages/seat-booking/seat-booking.module').then( m => m.SeatBookingPageModule)
  },
  {
    path: 'screen/:screen_id/movie/:movie_id/shows',
    loadChildren: () => import('./pages/shows/shows.module').then( m => m.ShowsPageModule)
  },
  {
    path: 'screen/:movie_id',
    loadChildren: () => import('./pages/screens/screens.module').then( m => m.ScreensPageModule)
  },
  {
    path: 'screen/:movie_id/:location',
    loadChildren: () => import('./pages/screens/screens.module').then( m => m.ScreensPageModule)
  },
  {
    path: 'screen/:screen_id/movie-details/:id',
    loadChildren: () => import('./pages/movie-details/movie-details.module').then( m => m.MovieDetailsPageModule)
  },
  {
    path: 'movie-details/:id',
    loadChildren: () => import('./pages/movie-details/movie-details.module').then( m => m.MovieDetailsPageModule)
  },
  {
    path: 'theatre/:theatre_id/screens',
    loadChildren: () => import('./pages/screens/screens.module').then( m => m.ScreensPageModule)
  },
  {
    path: 'screen-movies/:id',
    loadChildren: () => import('./pages/screen-movies/screen-movies.module').then( m => m.ScreenMoviesPageModule)
  },
  {
    path: 'starting-page',
    loadChildren: () => import('./pages/starting-page/starting-page.module').then( m => m.StartingPagePageModule)
  },
  {
    path: 'sign-in',
    //loadChildren: () => import('./pages/sign-in/sign-in.module').then( m => m.SignInPageModule)
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'sign-up',
    //loadChildren: () => import('./pages/sign-up/sign-up.module').then( m => m.SignUpPageModule)
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  { path: '', redirectTo: 'index', pathMatch: 'full' },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfilePageModule)
  },
  {
    path: 'my-bookings',
    loadChildren: () => import('./pages/my-bookings/my-bookings.module').then( m => m.MyBookingsPageModule)
  },
  {
    path: 'movies',
    loadChildren: () => import('./pages/movies/movies.module').then( m => m.MoviesPageModule)
  },
  {
    path: 'movie-list',
    loadChildren: () => import('./pages/movie-list/movie-list.module').then( m => m.MovieListPageModule)
  },
  // {
  //   path: 'subscription',
  //   loadChildren: () => import('./pages/subscription/subscription.module').then( m => m.SubscriptionPageModule)
  // },
  {
    path: 'payment/:id',
    loadChildren: () => import('./pages/payment/payment.module').then( m => m.PaymentPageModule)
  },
  {
    path: 'movie-info',
    loadChildren: () => import('./pages/movie-info/movie-info.module').then( m => m.MovieInfoPageModule)
  },
  {
    path: 'booking-details/:id',
    loadChildren: () => import('./pages/booking-details/booking-details.module').then( m => m.BookingDetailsPageModule)
  },
  {
    path: 'quiz-list',
    loadChildren: () => import('./pages/quiz-list/quiz-list.module').then( m => m.QuizListPageModule)
  },
  {
    path: 'quiz-select',
    loadChildren: () => import('./pages/quiz-select/quiz-select.module').then( m => m.QuizSelectPageModule)
  },
  {
    path: 'quiz-questions/:quizId/:quizName',
    loadChildren: () => import('./pages/quiz-questions/quiz-questions.module').then( m => m.QuizQuestionsPageModule)
  },
  {
    path: 'quiz-result',
    loadChildren: () => import('./pages/quiz-result/quiz-result.module').then( m => m.QuizResultModule)
  },
  {
    path: 'my-quiz-list',
    loadChildren: () => import('./pages/my-quiz-list/my-quiz-list.module').then( m => m.MyQuizListPageModule)
  },
  {
    path: 'my-quiz-summary/:id',
    loadChildren: () => import('./pages/my-quiz-summary/my-quiz-summary.module').then( m => m.MyQuizSummaryPageModule)
  },
  {
    path: 'my-vouchers',
    loadChildren: () => import('./pages/my-vouchers/my-vouchers.module').then( m => m.MyVouchersPageModule)
  },
  {
    path: 'complaints',
    loadChildren: () => import('./pages/complaints/complaints.module').then( m => m.ComplaintsPageModule)
  },
  {
    path: 'referrals',
    loadChildren: () => import('./pages/referrals/referrals.module').then( m => m.ReferralsPageModule)
  },
  {
    path: 'how-to-use',
    loadChildren: () => import('./pages/how-to-use/how-to-use.module').then( m => m.HowToUsePageModule)
  },
  {
    path: 'about',
    loadChildren: () => import('./pages/about/about.module').then( m => m.AboutPageModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./pages/terms/terms.module').then( m => m.TermsPageModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then( m => m.PrivacyPolicyPageModule)
  },
  {
    path: 'reffer-text-friend',
    loadChildren: () => import('./pages/reffer-text-friend/reffer-text-friend.module').then( m => m.RefferTextFriendPageModule)
  },
  {
    path: 'trailors/:type/:cat/:catname',
    loadChildren: () => import('./pages/trailors/trailors.module').then( m => m.TrailorsPageModule)
  },
  {
    path: 'trailor',
    loadChildren: () => import('./pages/trailor/trailor.module').then( m => m.TrailorPageModule)
  },
  {
    path: 'landing',
    loadChildren: () => import('./pages/landing/landing.module').then( m => m.LandingPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'onboard',
    loadChildren: () => import('./pages/onboard/onboard.module').then( m => m.OnboardPageModule)
  },
  {
    path: 'about',
    loadChildren: () => import('./pages/about/about.module').then( m => m.AboutPageModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./pages/terms/terms.module').then( m => m.TermsPageModule)
  },
  {
    path: 'profileedit',
    loadChildren: () => import('./pages/profileedit/profileedit.module').then( m => m.ProfileeditPageModule)
  },
  {
    path: 'wallet',
    loadChildren: () => import('./pages/wallet/wallet.module').then( m => m.WalletPageModule)
  },
  {
    path: 'buy-voucher-category/:id',
    loadChildren: () => import('./pages/buyvouchers/buyvouchers.module').then( m => m.BuyvouchersPageModule)
  },
  {
    path: 'voucher-view/:amount/:vcid/:validity',
    loadChildren: () => import('./pages/buyvoucherview/buyvoucherview.module').then( m => m.BuyvoucherviewPageModule)
  },
  {
    path: 'mybuyvouchers',
    loadChildren: () => import('./pages/mybuyvouchers/mybuyvouchers.module').then( m => m.MybuyvouchersPageModule)
  },
  {
    path: 'movie-location/:id',
    loadChildren: () => import('./pages/movielocation/movielocation.module').then( m => m.MovielocationPageModule)
  },
  {
    path: 'filter',
    loadChildren: () => import('./pages/filter/filter.module').then( m => m.FilterPageModule)
  },
  {
    path: 'buy-vouchers',
    loadChildren: () => import('./pages/buyvouchercategory/buyvouchercategory.module').then( m => m.BuyvouchercategoryPageModule)
  },
  {
    path: 'recharge',
    loadChildren: () => import('./pages/recharge/recharge.module').then( m => m.RechargePageModule)
  },
  {
    path: 'recharge-biller/:name',
    loadChildren: () => import('./pages/recharge-biller/recharge-biller.module').then( m => m.RechargeBillerPageModule)
  },
  {
    path: 'recharge-payment/:name/:id/:biller',
    loadChildren: () => import('./pages/recharge-payment/recharge-payment.module').then( m => m.RechargePaymentPageModule)
  },
  {
    path: 'recharge-mobile/:name',
    loadChildren: () => import('./pages/recharge-mobile/recharge-mobile.module').then( m => m.RechargeMobilePageModule)
  },
  {
    path: 'recharge-transaction-detail/:id',
    loadChildren: () => import('./pages/recharge-transaction-detail/recharge-transaction-detail.module').then( m => m.RechargeTransactionDetailPageModule)
  },
  {
    path: 'recharge-transactions',
    loadChildren: () => import('./pages/recharge-transactions/recharge-transactions.module').then( m => m.RechargeTransactionsPageModule)
  },
  {
    path: 'recharge-status/:id',
    loadChildren: () => import('./pages/recharge-status/recharge-status.module').then( m => m.RechargeStatusPageModule)
  },
  {
    path: 'recharge-lpg/:name/:id/:biller',
    loadChildren: () => import('./pages/recharge-lpg/recharge-lpg.module').then( m => m.RechargeLpgPageModule)
  },














  {
    path: '**',
    redirectTo: 'index'
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
